import { configureStore, combineReducers } from "@reduxjs/toolkit";
import genericFormReducer from "@/store/genericForm/genericFormSlice";

// Optional persistence
import { persistReducer, persistStore } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";

const rootReducer = combineReducers({
  genericForm: genericFormReducer,
});

const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: ["genericForm"], // only persist generic form cache
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefault) =>
    getDefault({
      serializableCheck: false, // because redux-persist stores non-serializable metadata
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
